'use strict'

import { ParseError } from './puzzle.js'
import { Crossword } from './crossword.js'
import { Cell, Clue } from './grid.js'

export class AcrossLite extends Crossword {
  /**
   * Really should use importPuzzle instead of the constructor
   * for importing.
   */
  constructor (data = new ArrayBuffer()) {
    super(data)

    this._blockchr = '.'
    this._separator = 0x00
    this._currentOffset = 44
  }

  // Parses all relevant information from _data.
  _parsePuzzle () {
    this._setHeader()

    // Sets the keys.
    this.key = true

    // Sets basic puzzle data.
    this._setPuzzleData()

    // Assign advanced puzzle data.
    this._setCells()
    this._setClues()

    return this
  }

  // Sets the checksum, puzzle dimensions, and puzzle state.
  _setHeader () {
    /*
    // Currently not used, but will be for creation.
    const header = "ACROSS&DOWN\0";
    const header_length = 0x34;
    const width_offset = 0x2c;
    */

    this.checksum = null
    this.clueCount = this._data[this._currentOffset + 2]

    this._setDims()
    this._setPuzzleStates()
  }

  // Sets the puzzle state (encrypted, locked, etc.)
  _setPuzzleStates () {
    const puzzleStates = {
      4: 'encrypted',
      5: 'arrow',
      6: 'locked',
      7: 'diagramless'
    }

    this._currentOffset = 50

    let puzzleState = puzzleStates[this._data[this._currentOffset]]
    this.puzzleStates = [ puzzleState ]
  }

  // Sets the height/width of the puzzle.
  _setDims () {
    this.grid.height = this._data[this._currentOffset]
    this.grid.width = this._data[this._currentOffset + 1]
  }

  // Sets the puzzle title, author, and copyright information.
  _setPuzzleData () {
    let chunkSize = 0

    let strings = []

    for (let i = this._currentOffset, len = this._data.length; i < len; i++) {
      // If we encounter a double-separator, note the offset and exit the loop.
      // @note Not sure why this is here, as it appears unnecessary and broken.
      //   Retaining it for now, but the exit has been removed.
      if (this._data[i] === this._separator &&
        this._data[i + 1] &&
        this._data[i - 1] === this._separator
      ) {
        this._currentOffset = i
        // break
      }

      /**
       * We've encountered a single-separator, so go back and get the string
       * it ends.
       */
      if (this._data[i] === this._separator) {
        let arr = this._data.slice(i - chunkSize, i)

        let str = []
        for (let j = 0, stringLen = arr.length; j < stringLen; j++) {
          // Convert the string.
          str.push(String.fromCharCode(arr[j]))
        }

        strings.push(str.join(''))
        chunkSize = 0
      } else {
        chunkSize += 1
      }
    }

    // Assign the basic puzzle data.
    console.log('STRINGS')
    console.log(this._data)
    this.title = strings[0]
    this.author = strings[1]
    this.copyright = strings[2]
    this._allClues = strings.splice(3)
  }

  // Sets the puzzle cells based on the key and gridKey.
  _setCells () {
    let cells = []

    for (let x = 0, maxWidth = this.grid.width; x < maxWidth; x++) {
      for (let y = 0, maxHeight = this.grid.height; y < maxHeight; y++) {
        let idx = this.grid.idxFromCoords(x, y)
        let chr = String.fromCharCode(this.key[idx])
        let isBlock = this.isBlockChr(chr)

        cells.push(
          new Cell({
            'answer': (isBlock ? null : chr.toUpperCase()),
            'cellType': (isBlock ? 'block' : null),
            'idx': this.grid.idxFromCoords(x, y),
            'x': x,
            'y': y
          })
        )
      }
    }

    this.grid.cells = cells
    this._setCellNumbers()
  }

  /**
   * Verify whether the passed character is considered a block character.
   *
   * @param chr [String]
   *
   * @return [Boolean] denoting whether the passed character is a block
   *  character or not.
   */
  isBlockChr (chr) {
    return chr === this._blockchr
  }

  // Sets the puzzle clues based on the grid.
  _setClues () {
    let axes = {}
    let numCount = 0

    let cell, cellClue
    for (let i = 0, len = this.grid.cells.length; i < len; i++) {
      cell = this.grid.cells[i]

      if (!cell.cellNumber) {
        continue
      }

      cell.axes.forEach(axis => {
        axes[axis] = true

        cellClue = new Clue({
          'axis': axis,
          'clueString': this._allClues[numCount],
          'idx': cell.idx,
          'clueNumber': cell.cellNumber,
          'x': cell.x,
          'y': cell.y
        })

        this.grid.cells[i].clues.push(cellClue)
        this.clues.push(cellClue)

        numCount += 1
      })
    }

    let axisKeys = Object.keys(axes)
    for (let i = 0, len = axisKeys.length; i < len; i++) {
      this.axes.push(axisKeys[i])
    }
  }

  // Getters and Setters

  // We currently do not validate the checksum.
  set checksum (value) {
    this['_checksum'] = value
    this['_checksumValid'] = true

    if (!this.checksumValid) {
      throw new ParseError('Invalid checksum')
    }

    return this['_checksum']
  }

  get checksumValid () {
    return this['_checksumValid']
  }

  set checksumValid (value = false) {
    this['_checksumValid'] = true
  }

  get clueCount () {
    return this['_clueCount']
  }

  set clueCount (value) {
    this['_clueCount'] = value
  }

  // Sets the answer and grid layout keys.
  set key (value) {
    let cellCount = (this.grid.height * this.grid.width)

    let startOffset = 52
    let endOffset = 52 + cellCount

    this['_key'] = this._data.slice(startOffset, endOffset)

    this._currentOffset = endOffset + cellCount

    this['gridKey'] = this._data.slice(endOffset, this._currentOffset)
  }

  get key () {
    return this['_key']
  }

  get gridKey () {
    return this['_gridKey']
  }

  set gridKey (value) {
    this['_gridKey'] = value
  }

  get clues () {
    return this['_clues']
  }

  set clues (value) {
    this['_clues'] = value
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/across_lite.js
// module id = 236
// module chunks = 0